export const apiUrl = '/api';